import * as React from 'react'

import style from '../styles/footer'

import { makeStyles } from '@fluentui/react-components'

const useStyles = makeStyles(style)

const Footer = () => {
  const classes = useStyles()

  return (
    <footer className={classes.footer}>
      v1.3.2
    </footer>
  )
}

export default Footer
